import { RatingWithLabel } from '@adotel/components'
import { Typography } from '@material-ui/core'
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined'

import { Entities } from '../../../../types/searchAvailability'
import useStyles from './styles/index.styles'

type Props = {
  searchData: Entities
}

const AccommodationNameAndAddress = ({ searchData }: Props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography className={classes.secondaryTitle}>
        {searchData?.entityBasicDetails.propertyName}
      </Typography>
      <div className={classes.hotelNamedetails}>
        <PlaceOutlinedIcon className={classes.icon}></PlaceOutlinedIcon>
        <Typography variant="caption" className={classes.greyText}>
          {searchData?.entityBasicDetails.address}
        </Typography>
        <div className={classes.seprator}></div>
        <RatingWithLabel
          value={searchData?.entityBasicDetails.starClass || 0}
          readOnly
          size="small"
          noHelperText
        />
      </div>
    </div>
  )
}

export default AccommodationNameAndAddress
